import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaRegFileAlt, FaEnvelope, FaSms } from 'react-icons/fa';
import './TemplateSidebar.css'; // Optional: for custom styling

const TemplateSidebar = () => {
  return (
    <div className="template-sidebar">
      {/* Templates - General */}
      <NavLink
        to="/templates/whatsapp"
        className={({ isActive }) => `sidebar-btn ${isActive ? 'active' : ''}`}
      >
        <FaRegFileAlt className="icon" />
        WhatsApp
      </NavLink>

      {/* Email Templates */}
      <NavLink
        to="/templates/email"
        className={({ isActive }) => `sidebar-btn ${isActive ? 'active' : ''}`}
      >
        <FaEnvelope className="icon" />
        Email
      </NavLink>

      {/* SMS Templates */}
      <NavLink
        to="/templates/sms"
        className={({ isActive }) => `sidebar-btn ${isActive ? 'active' : ''}`}
      >
        <FaSms className="icon" />
        SMS
      </NavLink>
    </div>
  );
};

export default TemplateSidebar;
